import { ITransaction } from "../api/transactions/types";
import { useDispatch, useSelector } from "react-redux";
import { selectTransactionsHistoryState } from "../store/transactionsHistory/transactionsHistory.selector";
import { 
    addTransactionToHistory as addTransactionToHistoryAction, 
    cleanUpRecentTransaction as cleanUpRecentTransactionAction,
    updateRecentTransactionId as updateRecentTransactionIdAction,
} from "../store/transactionsHistory/transactionsHistory.slice";

export const useTransactionHistory = () => {
    const dispatch = useDispatch();
    const {transactionsHistory, recentTransactionId} = useSelector(selectTransactionsHistoryState)

    // useEffect(() => {
    //     const transactions = localStorage.getItem('transactionsHistory');
    //     if (transactions) {
    //         setTransactionsHistory(JSON.parse(transactions));
    //     }
    //     const recentTransactionId = localStorage.getItem('recentTransactionId');
    //     if (recentTransactionId) {
    //         setRecentTransactionId(recentTransactionId);
    //     }
    // }, [recentTransactionId])

    const addTransactionToHistory = (transaction: ITransaction) => {
        // const transactions = localStorage.getItem('transactionsHistory');
        // const parsedTransactions: ITransaction[] = JSON.parse(transactions ?? '[]');
        // const isTransactionAlreadyInHistory = parsedTransactions.some(t => t._id === transaction._id);
        // if (isTransactionAlreadyInHistory) {
        //     return;
        // }
        // const newTransactionsHistory = [transaction, ...parsedTransactions.slice(0, 5)];
        // setTransactionsHistory(newTransactionsHistory);
        // localStorage.setItem('transactionsHistory', JSON.stringify(newTransactionsHistory));
        dispatch(addTransactionToHistoryAction(transaction));
    }

    const updateRecentTransactionId = (transactionId: string) => {
        // setRecentTransactionId(transactionId);
        // localStorage.setItem('recentTransactionId', transactionId);
        dispatch(updateRecentTransactionIdAction(transactionId));
    }

    const cleanUpRecentTransaction = () => {
        // setRecentTransactionId(undefined);
        // localStorage.removeItem('recentTransactionId');
        dispatch(cleanUpRecentTransactionAction())
    }

    return {
        transactionsHistory,
        recentTransactionId,
        addTransactionToHistory,
        cleanUpRecentTransaction,
        updateRecentTransactionId,
    }
};
